export const FETCHING_STATUS = "FETCHING_STATUS";

export const SET_IS_AUTHENTICATION = "SET_IS_AUTHENTICATION";
export const SET_AUTH_STATE = "SET_AUTH_STATE";

export const SET_USER_ID = "SET_USER_ID";
export const SET_USER_TYPE = "SET_USER_TYPE";

export const SET_USER_CONFIGS = "SET_USER_CONFIGS";
export const SET_USER = "SET_USER";


export const FETCHING_APPROVAL_LIST = "FETCHING_APPROVAL_LIST";
export const FETCHING_APPROVAL_LIST_SUCCESS = "FETCHING_APPROVAL_LIST_SUCCESS";
export const FETCHING_APPROVAL_LIST_FAILURE = "FETCHING_APPROVAL_LIST_FAILURE";

export const MEMBER_APPROVAL_STATUS = "MEMBER_APPROVAL_STATUS";
export const UPDATE_APPROVAL_STATUS = "UPDATE_APPROVAL_STATUS";

export const MEMBER_DECLINE_STATUS = "MEMBER_DECLINE_STATUS";
export const UPDATE_DECLINE_STATUS = "UPDATE_DECLINE_STATUS";

export const MOSQUE_DECLINE_STATUS ="MOSQUE_DECLINE_STATUS";
